export const AGES = [
    { id: '1', label: '1 day' },
    { id: '2', label: '21 days' },
    { id: '3', label: '200 days' },
]
